import { Box, TextField, Typography } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { selectAdditionalEquipment } from "../../../redux/selector";
import { actions } from "../../../redux/slice";
import { AdditionalEquipmentCode } from "../../../types";
import {
  ADDITIONAL_EQUIPMENT_COLUMNS,
  ADDITIONAL_EQUIPMENT_ROWS,
  ADDITIONAL_EQUIPMENT_SECTION_TITLE,
} from "../data";
import { useStyles } from "./styles";

const AdditionalEquipmentPanel = () => {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const isEnglish = !(i18n.language || "").startsWith("he");
  const additionalEquipment = useSelector(selectAdditionalEquipment);
  const styles = useStyles();

  if (!additionalEquipment) return null;

  const updateValue = (key: AdditionalEquipmentCode, value: string) =>
    dispatch(actions.updateAdditionalEquipmentValue({ key, value }));

  return (
    <Box className={styles.panelSection}>
      <Typography className={styles.panelSectionTitle}>
        {t(ADDITIONAL_EQUIPMENT_SECTION_TITLE)}
      </Typography>

      <Box className={styles.chassisTable}>
        {ADDITIONAL_EQUIPMENT_ROWS.map((row) => (
          <Box key={row.key} className={styles.chassisDataRow}>
              <Box className={styles.chassisFieldCell}>
                <Typography className={styles.chassisFieldLabel}>
                  {t(ADDITIONAL_EQUIPMENT_COLUMNS.symbol)}
                </Typography>
                <Typography className={styles.chassisSymbolValue}>{row.symbol}</Typography>
              </Box>
              <Box className={styles.chassisFieldCell}>
                <Typography className={styles.chassisFieldLabel}>
                  {t(ADDITIONAL_EQUIPMENT_COLUMNS.description)}
                </Typography>
                <Typography className={styles.chassisDescriptionValue}>
                  {t(row.descriptionKey)}
                </Typography>
              </Box>
              <Box className={styles.chassisInputGroup}>
                <Box
                  className={styles.chassisInputFieldCell}
                  style={isEnglish ? { width: "auto", minWidth: "auto" } : {}}
                >
                  <Typography
                    className={styles.chassisFieldLabel}
                    style={isEnglish ? { whiteSpace: "nowrap" } : {}}
                  >
                    {t(ADDITIONAL_EQUIPMENT_COLUMNS.value)}
                  </Typography>
                  <TextField
                    className={styles.chassisValueInput}
                    variant="outlined"
                    value={additionalEquipment[row.key].value}
                    onChange={(event) => updateValue(row.key, event.target.value)}
                  />
                </Box>
                <Box
                  className={styles.chassisInputFieldCell}
                  style={isEnglish ? { width: "auto", minWidth: "auto" } : {}}
                >
                  <Typography
                    className={styles.chassisFieldLabel}
                    style={isEnglish ? { whiteSpace: "nowrap" } : {}}
                  >
                    {t(ADDITIONAL_EQUIPMENT_COLUMNS.calculation)}
                  </Typography>
                  <Box className={styles.chassisCalculationValue}>
                    {additionalEquipment[row.key].calculationValue}
                  </Box>
                </Box>
              </Box>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default AdditionalEquipmentPanel;
